import { useCallback, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { Box, Button, Tooltip } from '@mui/material';
import { useEnqueueSnackbar } from 'hooks';
import type { PackEntry } from 'types/shared';
import {
  buildPackEntry,
  getTestCreativesIdToHypothesis,
  MIXED_PACK_TAG,
  removeCreativeIdsFromHypothesisPacks,
  selectionSpansMultipleHypotheses,
} from '../utils/hypothesisPackUtils';
import datadogActions, { DATADOG_EVENT } from 'lib/datadog';

const CreateMixedPackButton = () => {
  const { onShowAlert } = useEnqueueSnackbar();
  const { watch, setValue, trigger } = useFormContext();
  const selectedCreatives = watch('selectedCreatives') as string[];
  const packsWithCreatives = watch('packsWithCreatives') as PackEntry[];
  const testCreativesTab = watch('testCreativesTab') as string | undefined;


  const isCreateMixedPackAvailable = useMemo(() => {
    if (selectedCreatives.length < 2 || testCreativesTab === 'pack') {
      return false;
    }
    const idToHypothesis = getTestCreativesIdToHypothesis();
    console.log({selectedCreatives, testCreativesTab, idToHypothesis})
    return selectionSpansMultipleHypotheses(selectedCreatives, idToHypothesis);
  }, [selectedCreatives, testCreativesTab]);

  const handleCreateMixedPack = useCallback(() => {
    if (!selectedCreatives.length) return;

    const newPack = buildPackEntry(MIXED_PACK_TAG, [...selectedCreatives], {
      isMixedPack: true,
    });
    const packsWithoutSelectedCreatives = removeCreativeIdsFromHypothesisPacks(
      packsWithCreatives,
      selectedCreatives,
    );
    const updatedPacks = [...packsWithoutSelectedCreatives, newPack];
    setValue('packsWithCreatives', updatedPacks, { shouldValidate: true });
    setValue('activePacksWithCreatives', packsWithoutSelectedCreatives.length);
    setValue('selectedCreatives', [], { shouldValidate: true });

    onShowAlert('Mixed pack added', { delayAlert: 3500 });
    datadogActions.trackDatadogAction(DATADOG_EVENT.facebookPackAdded, {
      createdPacksCount: 1,
      selectedCreativesCount: selectedCreatives.length,
      isMixedPack: true,
    });

    void trigger('packsWithCreatives');
    void trigger('selectedCreatives');
  }, [
    onShowAlert,
    packsWithCreatives,
    selectedCreatives,
    setValue,
    trigger,
  ]);

  return (
    <Tooltip
      title="Select creatives from different hypotheses to create a mixed pack"
      placement="top"
    >
      <Box>
        <Button
          disabled={!isCreateMixedPackAvailable}
          variant="outlined"
          color="primary"
          onClick={handleCreateMixedPack}
        >
          Create mixed pack
        </Button>
      </Box>
    </Tooltip>
  );
};

export default CreateMixedPackButton;
